import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { MaintainceModeModal } from '../../utils/modal'

const baseUrl = process.env.REACT_APP_API_URL;

const MaintainceMode = () => {
    
    const [isModalOpen, setIsModalOpen] = useState(false);

    const fetchMaintenanceMode = async () => {
        try {
            const response = await fetch(`${baseUrl}config-variable-maintenance`, {
                headers: {
                    'accept': 'application/json',
                },
            });

            if (response.ok) {
                const data = await response.json();
                // Check if the "value" field is 1 to show the modal
                if (Array.isArray(data.data) && data.data.length > 0) {
                    const maintenanceConfig = data.data[0]; // Get the first element
                    if (maintenanceConfig.value === "1") {
                        setIsModalOpen(true);
                    }
                }
            } else {
                console.error('Failed to fetch maintenance mode status');
            }
        } catch (error) {
            toast.error(error?.response?.message);
            console.error('Error fetching maintenance mode:', error);
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        fetchMaintenanceMode();
    }, []);

    return (
        <div>
            {/* {isModalOpen && <MaintainceModeModal onClose={closeModal} />} */}
            <MaintainceModeModal isActive={isModalOpen} onClose={closeModal} />
        </div>
    )
}

export default MaintainceMode
